import React, { useEffect, useRef } from 'react';
import { gsap } from 'gsap';

const ServicesHero = () => {
  const heroRef = useRef(null);

  useEffect(() => {
    const ctx = gsap.context(() => {
      const tl = gsap.timeline({ defaults: { ease: 'power3.out' } });

      tl.fromTo(
        '.services-hero-line',
        { scaleX: 0, opacity: 0 },
        { scaleX: 1, opacity: 1, duration: 1 }
      );

      tl.fromTo(
        '.services-hero-title',
        { y: 40, opacity: 0 },
        { y: 0, opacity: 1, duration: 0.8 },
        '-=0.5'
      );

      tl.fromTo(
        '.services-hero-subtitle',
        { y: 30, opacity: 0 },
        { y: 0, opacity: 1, duration: 0.7 },
        '-=0.4'
      );
    }, heroRef);

    return () => ctx.revert();
  }, []);

  return (
    <section
      ref={heroRef}
      className="relative h-[50vh] min-h-[400px] flex items-center overflow-hidden"
    >
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://customer-assets.emergentagent.com/job_power-pulse-18/artifacts/ldy85806_After.jpg"
          alt="Professional electrical and security services"
          className="w-full h-full object-cover object-center"
        />
        {/* Dark Overlay */}
        <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/30" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-black/30" />
      </div>

      {/* Grid Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0 bg-[linear-gradient(rgba(229,33,51,0.2)_1px,transparent_1px),linear-gradient(90deg,rgba(229,33,51,0.2)_1px,transparent_1px)] bg-[size:60px_60px]" />
      </div>

      {/* Content */}
      <div className="container mx-auto px-6 pt-24 relative z-10">
        <div className="max-w-2xl">
          <div
            className="services-hero-line w-24 h-1 bg-gradient-to-r from-securelec-red to-securelec-red/50 mb-6 origin-left rounded-full"
            style={{ boxShadow: '0 0 20px rgba(229, 33, 51, 0.6)' }}
          />
          <h1 className="services-hero-title text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-4 tracking-tight drop-shadow-lg">
            Our Services
          </h1>
          <p className="services-hero-subtitle text-lg md:text-xl text-white/80 leading-relaxed drop-shadow-md">
            Comprehensive electrical and security solutions for residential and commercial properties.
          </p>
        </div>
      </div>

      {/* Bottom Gradient */}
      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-white to-transparent" />
    </section>
  );
};

export default ServicesHero;
